import { isAsyncThunkAction } from "@reduxjs/toolkit"
import { useState } from "react"
import RestPrivateAntesala from "../../../helpers/RestPrivateApi"

const MyRecaptcha = ({ setRecaptcha, isChecked, setIsChecked }) => {
    const [isLoading, setIsLoading] = useState(false)

    const handleCheckboxClick = async () => {
        if (isChecked) return

        setIsLoading(true)

        const formData = new FormData();

        const response = await RestPrivateAntesala({
            url: "/captcha/generate",
            formData: formData,
            setLoading: setIsLoading,
            method: "POST",
        });

        if (response.status == 200) {
            setIsChecked(true)
            setRecaptcha(response.data.data.token)
        }
    }

    return (

        <div className="border rounded p-4 bg-light">
            <div className="d-flex align-items-center">
                <div className="position-relative me-3">
                    <input
                        type="checkbox"
                        id="recaptcha-checkbox"
                        checked={isChecked}
                        onChange={() => { }}
                        onClick={handleCheckboxClick}
                        disabled={isLoading || isChecked}
                        className="form-check-input"
                        style={{ width: "24px", height: "24px", cursor: "pointer" }}
                    />
                    {isLoading && (
                        <div className="position-absolute top-0 start-0 d-flex align-items-center justify-content-center w-100 h-100">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="visually-hidden">Cargando...</span>
                            </div>
                        </div>
                    )}
                    {isChecked && (
                        <svg
                            className="position-absolute top-0 start-0 text-success"
                            width="24"
                            height="24"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            style={{ pointerEvents: "none" }}
                        >
                            <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                            />
                        </svg>
                    )}
                </div>

                <label
                    htmlFor="recaptcha-checkbox"
                    className="text-dark me-auto"
                    style={{ cursor: "pointer", userSelect: "none" }}
                >
                    Aceptar
                </label>

                <div className="d-flex flex-column text-center align-items-center text-muted small">
                    <svg className="text-primary mb-1" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    <span>Acepta terminos y condiciones</span>
                </div>
            </div>
        </div>
    )
}

export default MyRecaptcha